<template>
  <div>
    <div
      style="position: fixed; top: 20px; z-index: 5; backdrop-filter: blur(2px)"
      v-if="loaderStatus"
    >
      <Spinner />
    </div>
    <div class="main-container bluebtn overflow-hidden">
      <div class="dashboardAdmin-header">
        <div class="dashboardAdmin-header-main-head">Review Candidates</div>
      </div>
      <div class="viewopsheadjdcontainer mt-2">
        <div class="newInt-control-tabs">
          <b-tabs v-model="tabIndex">
            <b-tab
              title="Pending Candidates"
              @click="
                openPreview = false;
                approved = '0';
                page = 1;
                goToPage = null;
                getCandidates();
              "
            >
              <div>
                <template
                  v-if="
                    pendingCandidates.length == 0 &&
                    !loaderStatus &&
                    searchQuery == ''
                  "
                >
                  <div
                    class="
                      bu-head-no-data-class
                      d-flex
                      align-items-center
                      justify-content-center
                      flex-column
                    "
                  >
                    <div>
                      <img
                        src="../../assets/newJD/newCand-empty-pic.svg"
                        alt=""
                      />
                    </div>
                    <div class="ml-4 teams-empty-container-font">
                      There are no pending candidates
                    </div>
                  </div>
                </template>
                <template v-else>
                  <!-- new table design starts from here -->
                  <div class="newJD-main-table">
                    <div class="newJD-table-head">
                      <div class="text-left opsCanDash-margin-name width-25">
                        <span>Candidate Name</span>
                        <template v-if="sortBy === 'name'">
                          <img
                            v-if="sortByValue"
                            @click="
                              sortByValue = !sortByValue;
                              order = '-1';
                              getCandidates();
                            "
                            class="pointer ml-2"
                            src="../../assets/img/accessconnew/ascSort.svg"
                            alt=""
                          />
                          <img
                            v-if="!sortByValue"
                            @click="
                              sortByValue = !sortByValue;
                              order = '1';
                              getCandidates();
                            "
                            class="pointer ml-2"
                            src="../../assets/img/accessconnew/descSort.svg"
                            alt=""
                          />
                        </template>
                        <img
                          v-else
                          @click="
                            sortBy = 'name';
                            sortByValue = true;
                            order = '1';
                            getCandidates();
                          "
                          class="pointer ml-2"
                          src="../../assets/img/accessconnew/nosort.svg"
                          alt=""
                        />
                      </div>
                      <div class="text-left width-25">
                        <span>Email</span>
                        <template v-if="sortBy === 'email'">
                          <img
                            v-if="sortByValue"
                            @click="
                              sortByValue = !sortByValue;
                              order = '-1';
                              getCandidates();
                            "
                            class="pointer ml-2"
                            src="../../assets/img/accessconnew/ascSort.svg"
                            alt=""
                          />
                          <img
                            v-if="!sortByValue"
                            @click="
                              sortByValue = !sortByValue;
                              order = '1';
                              getCandidates();
                            "
                            class="pointer ml-2"
                            src="../../assets/img/accessconnew/descSort.svg"
                            alt=""
                          />
                        </template>
                        <img
                          v-else
                          @click="
                            sortBy = 'email';
                            sortByValue = true;
                            order = '1';
                            getCandidates();
                          "
                          class="pointer ml-2"
                          src="../../assets/img/accessconnew/nosort.svg"
                          alt=""
                        />
                      </div>
                      <div class="text-left width-25">
                        <span>Job Title</span>
                      </div>
                      <div class="text-left width-15">
                        <span>Sent on</span>
                      </div>
                      <div class="text-left width-10">Action</div>
                    </div>

                    <div class="newJD-table-body" ref="tableContainer1">
                      <template
                        v-if="
                          pendingCandidates.length == 0 &&
                          !loaderStatus &&
                          searchQuery != ''
                        "
                      >
                        <div
                          class="
                            h-100
                            d-flex
                            align-items-center
                            justify-content-center
                            flex-column
                          "
                        >
                          <div>
                            <img
                              src="../../assets/newJD/newCand-empty-pic.svg"
                              alt=""
                            />
                          </div>
                          <div class="ml-4 teams-empty-container-font">
                            No matching results for "{{ searchQuery }}"
                          </div>
                        </div>
                      </template>
                      <template v-else>
                        <div
                          class="newJD-table-row"
                          v-for="(item, index) in pendingCandidates"
                          :key="index"
                        >
                          <div
                            class="text-left opsCanDash-margin-name width-25"
                          >
                            <span class="newJD-gridgreencolorDynamic"></span>
                            <span
                              class="text-truncate d-inline-block width-set"
                              v-b-tooltip.hover.top="item.name"
                            >
                              {{ item.name }}
                            </span>
                          </div>
                          <div class="text-left text-truncate width-25">
                            <span>{{ item.email }}</span>
                          </div>
                          <div class="text-left width-25">
                            <span
                              class="text-truncate d-inline-block width-set"
                              v-b-tooltip.hover.top="item.jobTitle"
                              >{{ item.jobTitle }}</span
                            >
                          </div>
                          <div class="text-left text-capitalize width-15">
                            <span>{{ item.updatedAt | formatdate }} </span>
                          </div>
                          <div class="text-left width-10">
                            <span class="pl-2">
                              <img
                                @click="
                                  (isPending = true), openPreviewSlide(item)
                                "
                                class="pointer"
                                v-b-tooltip.hover.top="'Click to view'"
                                src="../../assets/newJD/newCand-view-icon.svg"
                                alt=""
                            /></span>
                          </div>
                        </div>
                      </template>
                    </div>
                    <div
                      class="
                        acs-paginaTion-new
                        d-flex
                        justify-content-between
                        align-items-center
                      "
                    >
                      <div class="d-flex">
                        <span class="acs-gotopage-text p-1">Go to page</span>
                        <b-form-input
                          type="text"
                          class="acs-pagination-num mr-1"
                          v-model="goToPage"
                          @keyup.enter="
                            goToPage == null ||
                            goToPage == '' ||
                            !iscontainsNumber
                              ? ''
                              : goToPages()
                          "
                          @keypress="NumbersOnly"
                          @paste="handlePaste"
                        ></b-form-input>
                        <div class="acs-pagination-addbtn">
                          <span
                            :class="
                              goToPage === null ||
                              goToPage == '' ||
                              !iscontainsNumber
                                ? 'disableDeleteIcon pl-3 mt-1'
                                : 'pointer pl-3 mt-1'
                            "
                          >
                            <img
                              @click="
                                goToPage == null ||
                                goToPage == '' ||
                                !iscontainsNumber
                                  ? ''
                                  : goToPages()
                              "
                              src="../../assets/panelist/page_arrow.svg"
                              alt
                            />
                          </span>
                        </div>
                      </div>
                      <div class="pagination">
                        <b-pagination
                          v-model.number="page"
                          @input="getCandidates(), (goToPage = null)"
                          :total-rows="total"
                          :per-page="count"
                          align="center"
                          first-number
                          last-number
                        >
                          <template #prev-text
                            ><span
                              ><img
                                src="../../assets/leftvector.svg"
                                alt=""
                              /> </span
                          ></template>
                          <template #next-text
                            ><span
                              ><img
                                src="../../assets/rightarrow.svg"
                                alt="" /></span
                          ></template>
                        </b-pagination>
                      </div>
                      <div class="d-flex align-items-center">
                        <PageInput
                          :pagecount="count"
                          @update-value="updatePage"
                        />

                        <div
                          class="
                            acs-gotopage-text
                            mr-2
                            ml-4
                            d-flex
                            justify-content-end
                          "
                        >
                          Showing :
                          <div
                            class="text-truncate ml-2 results-individual-width"
                            v-if="pageStart > total"
                          >
                            0
                          </div>
                          <div
                            v-else
                            class="text-truncate ml-2 results-individual-width"
                          >
                            {{ pageStart }}
                          </div>
                          <div class="text-truncate results-individual-width">
                            -
                          </div>
                          <div class="text-truncate results-individual-width">
                            {{ pageEnd }}
                          </div>
                          <div
                            class="text-truncate ml-1 results-individual-width"
                          >
                            of
                          </div>
                          <div
                            class="text-truncate ml-1 results-individual-width"
                          >
                            {{ total }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </b-tab>
            <b-tab
              title="Accepted Candidates"
              @click="
                openPreview = false;
                approved = '1';
                page = 1;
                goToPage = null;
                getCandidates();
              "
            >
              <div>
                <template
                  v-if="
                    pendingCandidates.length == 0 &&
                    !loaderStatus &&
                    searchQuery == ''
                  "
                >
                  <div
                    class="
                      bu-head-no-data-class
                      d-flex
                      align-items-center
                      justify-content-center
                      flex-column
                    "
                  >
                    <div>
                      <img
                        src="../../assets/newJD/newCand-empty-pic.svg"
                        alt=""
                      />
                    </div>
                    <div class="ml-4 teams-empty-container-font">
                      There are no approved candidates
                    </div>
                  </div>
                </template>
                <template v-else>
                  <!-- new table design starts -->
                  <div class="newJD-main-table">
                    <div class="newJD-table-head">
                      <div class="text-left opsCanDash-margin-name width-25">
                        <span>Candidate Name</span
                        ><template v-if="sortBy === 'name'">
                          <img
                            v-if="sortByValue"
                            @click="
                              sortByValue = !sortByValue;
                              order = '-1';
                              getCandidates();
                            "
                            class="pointer ml-2"
                            src="../../assets/img/accessconnew/ascSort.svg"
                            alt=""
                          />
                          <img
                            v-if="!sortByValue"
                            @click="
                              sortByValue = !sortByValue;
                              order = '1';
                              getCandidates();
                            "
                            class="pointer ml-2"
                            src="../../assets/img/accessconnew/descSort.svg"
                            alt=""
                          />
                        </template>
                        <img
                          v-else
                          @click="
                            sortBy = 'name';
                            sortByValue = true;
                            order = '1';
                            getCandidates();
                          "
                          class="pointer ml-2"
                          src="../../assets/img/accessconnew/nosort.svg"
                          alt=""
                        />
                      </div>
                      <div class="text-left width-25">
                        <span>Email</span
                        ><template v-if="sortBy === 'email'">
                          <img
                            v-if="sortByValue"
                            @click="
                              sortByValue = !sortByValue;
                              order = '-1';
                              getCandidates();
                            "
                            class="pointer ml-2"
                            src="../../assets/img/accessconnew/ascSort.svg"
                            alt=""
                          />
                          <img
                            v-if="!sortByValue"
                            @click="
                              sortByValue = !sortByValue;
                              order = '1';
                              getCandidates();
                            "
                            class="pointer ml-2"
                            src="../../assets/img/accessconnew/descSort.svg"
                            alt=""
                          />
                        </template>
                        <img
                          v-else
                          @click="
                            sortBy = 'email';
                            sortByValue = true;
                            order = '1';
                            getCandidates();
                          "
                          class="pointer ml-2"
                          src="../../assets/img/accessconnew/nosort.svg"
                          alt=""
                        />
                      </div>
                      <div class="text-left width-25">
                        <span>Job Title</span>
                      </div>
                      <div class="text-left width-15">
                        <span>Accepted on</span>
                      </div>
                      <div class="text-left width-10">Action</div>
                    </div>
                    <div class="newJD-table-body" ref="tableContainer2">
                      <template
                        v-if="
                          pendingCandidates.length == 0 &&
                          !loaderStatus &&
                          searchQuery != ''
                        "
                      >
                        <div
                          class="
                            h-100
                            d-flex
                            align-items-center
                            justify-content-center
                            flex-column
                          "
                        >
                          <div>
                            <img
                              src="../../assets/newJD/newCand-empty-pic.svg"
                              alt=""
                            />
                          </div>
                          <div class="ml-4 teams-empty-container-font">
                            No matching results for "{{ searchQuery }}"
                          </div>
                        </div>
                      </template>
                      <template v-else>
                        <div
                          class="newJD-table-row"
                          v-for="(item, index) in pendingCandidates"
                          :key="index"
                        >
                          <div
                            class="text-left opsCanDash-margin-name width-25"
                          >
                            <span class="newJD-gridgreencolorDynamic"></span>
                            <span
                              class="text-truncate d-inline-block width-set"
                              v-b-tooltip.hover.top="item.name"
                            >
                              {{ item.name }}
                            </span>
                          </div>
                          <div class="text-left text-truncate width-25">
                            <span>{{ item.email }}</span>
                          </div>
                          <div class="text-left width-25">
                            <span
                              class="text-truncate d-inline-block width-set"
                              v-b-tooltip.hover.top="item.jobTitle"
                              >{{ item.jobTitle }}</span
                            >
                          </div>
                          <div class="text-left text-capitalize width-15">
                            <span>{{ item.updatedAt | formatdate }} </span>
                          </div>
                          <div class="text-left width-10">
                            <span class="pl-3">
                              <img
                                v-b-tooltip.hover.top="'Click to view'"
                                @click="
                                  (isPending = false), openPreviewSlide(item)
                                "
                                src="../../assets/img/accessconnew/blueEye.svg"
                                alt="/"
                                class="pointer"
                              />
                            </span>
                          </div>
                        </div>
                      </template>
                    </div>
                    <div
                      class="
                        acs-paginaTion-new
                        d-flex
                        justify-content-between
                        align-items-center
                      "
                    >
                      <div class="d-flex">
                        <span class="acs-gotopage-text p-1">Go to page</span>
                        <b-form-input
                          type="text"
                          class="acs-pagination-num mr-1"
                          v-model="goToPage"
                          @keyup.enter="
                            goToPage == null ||
                            goToPage == '' ||
                            !iscontainsNumber
                              ? ''
                              : goToPages()
                          "
                          @keypress="NumbersOnly"
                          @paste="handlePaste"
                        ></b-form-input>
                        <div class="acs-pagination-addbtn">
                          <span
                            :class="
                              goToPage === null ||
                              goToPage == '' ||
                              !iscontainsNumber
                                ? 'disableDeleteIcon pl-3 mt-1'
                                : 'pointer pl-3 mt-1'
                            "
                          >
                            <img
                              @click="
                                goToPage == null ||
                                goToPage == '' ||
                                !iscontainsNumber
                                  ? ''
                                  : goToPages()
                              "
                              src="../../assets/panelist/page_arrow.svg"
                              alt
                            />
                          </span>
                        </div>
                      </div>
                      <div class="pagination">
                        <b-pagination
                          v-model.number="page"
                          @input="getCandidates(), (goToPage = null)"
                          :total-rows="total"
                          :per-page="count"
                          align="center"
                          first-number
                          last-number
                        >
                          <template #prev-text
                            ><span
                              ><img
                                src="../../assets/leftvector.svg"
                                alt=""
                              /> </span
                          ></template>
                          <template #next-text
                            ><span
                              ><img
                                src="../../assets/rightarrow.svg"
                                alt="" /></span
                          ></template>
                        </b-pagination>
                      </div>
                      <div class="d-flex align-items-center">
                        <PageInput
                          :pagecount="count"
                          @update-value="updatePage"
                        />

                        <div
                          class="
                            acs-gotopage-text
                            mr-2
                            ml-4
                            d-flex
                            justify-content-end
                          "
                        >
                          Showing :
                          <div
                            class="text-truncate ml-2 results-individual-width"
                            v-if="pageStart > total"
                          >
                            0
                          </div>
                          <div
                            v-else
                            class="text-truncate ml-2 results-individual-width"
                          >
                            {{ pageStart }}
                          </div>
                          <div class="text-truncate results-individual-width">
                            -
                          </div>
                          <div class="text-truncate results-individual-width">
                            {{ pageEnd }}
                          </div>
                          <div
                            class="text-truncate ml-1 results-individual-width"
                          >
                            of
                          </div>
                          <div
                            class="text-truncate ml-1 results-individual-width"
                          >
                            {{ total }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </b-tab>
            <b-tab
              title="Rejected Candidates"
              @click="
                openPreview = false;
                approved = '2';
                page = 1;
                goToPage = null;
                getCandidates();
              "
            >
              <div>
                <template
                  v-if="
                    pendingCandidates.length == 0 &&
                    !loaderStatus &&
                    searchQuery == ''
                  "
                >
                  <div
                    class="
                      bu-head-no-data-class
                      d-flex
                      align-items-center
                      justify-content-center
                      flex-column
                    "
                  >
                    <div>
                      <img
                        src="../../assets/newJD/newCand-empty-pic.svg"
                        alt=""
                      />
                    </div>
                    <div class="ml-4 teams-empty-container-font">
                      There are no rejected candidates
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div class="newJD-main-table">
                    <div class="newJD-table-head">
                      <div class="text-left opsCanDash-margin-name width-25">
                        <span>Candidate Name</span
                        ><template v-if="sortBy === 'name'">
                          <img
                            v-if="sortByValue"
                            @click="
                              sortByValue = !sortByValue;
                              order = '-1';
                              getCandidates();
                            "
                            class="pointer ml-2"
                            src="../../assets/img/accessconnew/ascSort.svg"
                            alt=""
                          />
                          <img
                            v-if="!sortByValue"
                            @click="
                              sortByValue = !sortByValue;
                              order = '1';
                              getCandidates();
                            "
                            class="pointer ml-2"
                            src="../../assets/img/accessconnew/descSort.svg"
                            alt=""
                          />
                        </template>
                        <img
                          v-else
                          @click="
                            sortBy = 'name';
                            sortByValue = true;
                            order = '1';
                            getCandidates();
                          "
                          class="pointer ml-2"
                          src="../../assets/img/accessconnew/nosort.svg"
                          alt=""
                        />
                      </div>
                      <div class="text-left width-25">
                        <span>Email</span
                        ><template v-if="sortBy === 'email'">
                          <img
                            v-if="sortByValue"
                            @click="
                              sortByValue = !sortByValue;
                              order = '-1';
                              getCandidates();
                            "
                            class="pointer ml-2"
                            src="../../assets/img/accessconnew/ascSort.svg"
                            alt=""
                          />
                          <img
                            v-if="!sortByValue"
                            @click="
                              sortByValue = !sortByValue;
                              order = '1';
                              getCandidates();
                            "
                            class="pointer ml-2"
                            src="../../assets/img/accessconnew/descSort.svg"
                            alt=""
                          />
                        </template>
                        <img
                          v-else
                          @click="
                            sortBy = 'email';
                            sortByValue = true;
                            order = '1';
                            getCandidates();
                          "
                          class="pointer ml-2"
                          src="../../assets/img/accessconnew/nosort.svg"
                          alt=""
                        />
                      </div>
                      <div class="text-left width-25">
                        <span>Job Title</span>
                      </div>
                      <div class="text-left width-15">
                        <span>Rejected on</span>
                      </div>
                      <div class="text-left width-10">Action</div>
                    </div>

                    <div class="newJD-table-body" ref="tableContainer3">
                      <template
                        v-if="
                          pendingCandidates.length == 0 &&
                          !loaderStatus &&
                          searchQuery != ''
                        "
                      >
                        <div
                          class="
                            h-100
                            d-flex
                            align-items-center
                            justify-content-center
                            flex-column
                          "
                        >
                          <div>
                            <img
                              src="../../assets/newJD/newCand-empty-pic.svg"
                              alt=""
                            />
                          </div>
                          <div class="ml-4 teams-empty-container-font">
                            No matching results for "{{ searchQuery }}"
                          </div>
                        </div>
                      </template>
                      <template v-else>
                        <div
                          class="newJD-table-row"
                          v-for="(item, index) in pendingCandidates"
                          :key="index"
                        >
                          <div
                            class="text-left opsCanDash-margin-name width-25"
                          >
                            <span class="newJD-gridgreencolorDynamic"></span>
                            <span
                              class="text-truncate d-inline-block width-set"
                              v-b-tooltip.hover.top="item.name"
                            >
                              {{ item.name }}
                            </span>
                          </div>
                          <div class="text-left text-truncate width-25">
                            <span>{{ item.email }}</span>
                          </div>
                          <div class="text-left width-25">
                            <span
                              class="text-truncate d-inline-block width-set"
                              >{{ item.jobTitle }}</span
                            >
                          </div>
                          <div class="text-left text-capitalize width-15">
                            <span>{{ item.updatedAt | formatdate }} </span>
                          </div>
                          <div class="text-left width-10">
                            <span class="pl-3">
                              <img
                                v-b-tooltip.hover.top="'Click to view'"
                                @click="
                                  (isPending = false), openPreviewSlide(item)
                                "
                                src="../../assets/img/accessconnew/blueEye.svg"
                                alt="/"
                                class="pointer"
                              />
                            </span>
                          </div>
                        </div>
                      </template>
                    </div>
                    <!-- table ends -->
                    <div
                      class="
                        acs-paginaTion-new
                        d-flex
                        justify-content-between
                        align-items-center
                      "
                    >
                      <div class="d-flex">
                        <span class="acs-gotopage-text p-1">Go to page</span>
                        <b-form-input
                          type="text"
                          class="acs-pagination-num mr-1"
                          v-model="goToPage"
                          @keyup.enter="
                            goToPage == null ||
                            goToPage == '' ||
                            !iscontainsNumber
                              ? ''
                              : goToPages()
                          "
                          @keypress="NumbersOnly"
                          @paste="handlePaste"
                        ></b-form-input>
                        <div class="acs-pagination-addbtn">
                          <span
                            :class="
                              goToPage === null ||
                              goToPage == '' ||
                              !iscontainsNumber
                                ? 'disableDeleteIcon pl-3 mt-1'
                                : 'pointer pl-3 mt-1'
                            "
                          >
                            <img
                              @click="
                                goToPage == null ||
                                goToPage == '' ||
                                !iscontainsNumber
                                  ? ''
                                  : goToPages()
                              "
                              src="../../assets/panelist/page_arrow.svg"
                              alt
                            />
                          </span>
                        </div>
                      </div>
                      <div class="pagination">
                        <b-pagination
                          v-model.number="page"
                          @input="getCandidates, (goToPage = null)"
                          :total-rows="total"
                          :per-page="count"
                          align="center"
                          first-number
                          last-number
                        >
                          <template #prev-text
                            ><span
                              ><img
                                src="../../assets/leftvector.svg"
                                alt=""
                              /> </span
                          ></template>
                          <template #next-text
                            ><span
                              ><img
                                src="../../assets/rightarrow.svg"
                                alt="" /></span
                          ></template>
                        </b-pagination>
                      </div>
                      <div class="d-flex align-items-center">
                        <PageInput
                          :pagecount="count"
                          @update-value="updatePage"
                        />

                        <div
                          class="
                            acs-gotopage-text
                            mr-2
                            ml-4
                            d-flex
                            justify-content-end
                          "
                        >
                          Showing :
                          <div
                            class="text-truncate ml-2 results-individual-width"
                            v-if="pageStart > total"
                          >
                            0
                          </div>
                          <div
                            v-else
                            class="text-truncate ml-2 results-individual-width"
                          >
                            {{ pageStart }}
                          </div>
                          <div class="text-truncate results-individual-width">
                            -
                          </div>
                          <div class="text-truncate results-individual-width">
                            {{ pageEnd }}
                          </div>
                          <div
                            class="text-truncate ml-1 results-individual-width"
                          >
                            of
                          </div>
                          <div
                            class="text-truncate ml-1 results-individual-width"
                          >
                            {{ total }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </div>
      <ViewCandidateStatus
        :openPreview="openPreview"
        :candDetails="candDetails"
        :isPending="isPending"
        :customFieldsArray="customFieldsArray"
        @close-review-cand="openPreview = false"
      />
    </div>
  </div>
</template>

<script>
import {
  finalSelectionReview,
  getCustomerFields,
} from "../../utils/apiFunctions";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
import { NumbersOnly } from "../../controllers/Candidate/helpers";
import PageInput from "../../components/InputComponents/PaginationInput.vue";
import ViewCandidateStatus from "../../views/OpsheadCandidatePortal/ViewCandidateStatus.vue";
import EventBus from "../../utils/eventBus";
import { mapGetters } from "vuex";
import commonFunc from "../../components/mixin/commonFunctions.js";

export default {
  name: "OpsheadCandDashboard",
  components: {
    Spinner,
    PageInput,
    ViewCandidateStatus,
  },
  mixins: [commonFunc],

  data() {
    return {
      //Boolean
      loaderStatus: false,
      sortByValue: false,
      filter: false,
      openPreview: false,
      isPending: false,

      //Strings
      approved: "0",
      order: "-1",
      sortBy: "createdAt",
      actionList: "",

      //Number
      count: 50,
      page: 1,
      goToPage: null,
      total: null,
      pageStart: null,
      pageEnd: null,
      tabIndex: 0,

      //Arrays
      pendingCandidates: [],
      customFieldsArray: [],

      // Objects
      candDetails: {},
    };
  },
  watch: {
    searchQuery(newValue, oldValue) {
      if (newValue != oldValue) {
        this.loaderStatus = true;
        if (newValue != "Loader") {
          this.getCandidates();
        }
      }
    },
    tabIndex(newValue) {
      let status;
      // Map the tabIndex value to the corresponding status
      switch (newValue) {
        case 0:
          status = "pending";
          break;
        case 1:
          status = "accepted";
          break;
        case 2:
          status = "rejected";
          break;
        default:
          status = "pending";
          break;
      }
      // Update the route with the new status query parameter
      this.$router.push({
        name: "ReviewCandidates",
        query: {
          status: status,
        },
      });
    },
  },
  filters: {
    formatdate(data) {
      if (!data) return "-";
      let formattedDate = data.slice(0, 10).split("-").reverse().join("-");
      return formattedDate;
    },
  },
  created() {
    this.getSingleFormData();
    if (this.$route.query.status) {
      this.setTabIndex();
    } else this.getCandidates();
    EventBus.$on("on-close-acceptreject", this.triggerClose);
  },
  destroyed() {
    EventBus.$off("on-close-acceptreject", this.triggerClose);
  },
  computed: {
    // To check if it does not contain an alphabet or zero
    iscontainsNumber() {
      return /^[1-9]\d*$/.test(this.goToPage);
    },
    totalPages() {
      return Math.ceil(this.total / this.count);
    },
    ...mapGetters(["roles"]),
    ...mapGetters("searchVUEX", {
      searchQuery: "getSearchQuery",
    }),
  },
  methods: {
    async getSingleFormData() {
      try {
        let parentID = "5";
        let response = await getCustomerFields({ parentID });
        if (response.status == 200) {
          this.customFieldsArray = response.data.data.fields;
        }
      } catch (error) {
        console.error(error);
      }
    },
    openPreviewSlide(item) {
      this.openPreview = true;
      this.candDetails = item;
    },

    updatePage(value) {
      this.count = value;
      this.page = 1;
      this.loaderStatus = true;
      this.getCandidates();
    },

    triggerClose() {
      this.openPreview = false;
      this.setTabIndex();
    },

    // Set tabIndex based on the query variables (check watcher)
    setTabIndex() {
      switch (this.$route.query.status) {
        case "accepted":
          this.tabIndex = 1;
          this.approved = "1";
          break;
        case "rejected":
          this.tabIndex = 2;
          this.approved = "2";
          break;
        case "pending":
        default:
          this.tabIndex = 0;
          this.approved = "0";
      }
      this.page = 1;
      this.goToPage = null;
      this.getCandidates();
    },
    NumbersOnly(evt) {
      NumbersOnly(evt);
    },
    goToPages() {
      this.page = Math.min(Math.max(1, this.goToPage), this.totalPages);
      this.goToPage = null;
      this.getCandidates();
    },
    async getCandidates() {
      this.loaderStatus = true;
      try {
        let payload = {
          count: this.count,
          page: this.page - 1,
          searchQuery: this.searchQuery,
          filters: {
            approved: this.approved,
          },
          sortBy: {
            column: this.sortBy,
            order: this.order,
          },
        };
        if (this.roles && this.roles.includes("VIEW_ADMIN")) {
          payload.admin = true;
        }
        const response = await finalSelectionReview(payload);
        if (response.status == 200) {
          this.pendingCandidates = response.data.data.data;
          this.total = response.data.data.total;
          this.pageStart = response.data.data.pageStart;
          this.pageEnd = response.data.data.pageEnd;
          this.loaderStatus = false;

          // Determine the tableRef based on the route query status
          let tableRef;
          switch (this.$route.query.status) {
            case "rejected":
              tableRef = "tableContainer3";
              break;
            case "accepted":
              tableRef = "tableContainer2";
              break;
            case "pending":
              tableRef = "tableContainer1";
              break;
            default:
              tableRef = "tableContainer1";
              break;
          }

          // Scroll to the top of the specified table container with smooth behavior
          this.$nextTick(() => {
            const tableContainer = this.$refs[tableRef];
            if (tableContainer) {
              tableContainer.scrollTo({ top: 0, behavior: "smooth" });
            }
          });
        }
      } catch (error) {
        this.loaderStatus = false;
        throw new Error(`Failed! getCandidates ! status: ${error.status}`);
      }
    },
  },
};
</script>

<style scoped>
.opsCanDash-margin-name {
  padding-left: 2%;
}

.width-set {
  min-width: auto;
  max-width: 90%;
}
.width-10 {
  width: 10%;
}
.width-15 {
  width: 15%;
}
.width-25 {
  width: 25%;
}

.disableDeleteIcon {
  opacity: 0.6;
  cursor: initial;
}

.bu-head-no-data-class {
  height: calc(100vh - 150px);
}
</style>
